import * as i0 from '@angular/core';
import { Component, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@tangilla/tg-ng-payments/src/lib/payment-services';

class RecnIframeComponent {
    constructor(recnService) {
        this.recnService = recnService;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeComponent, deps: [{ token: i1.RecnService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: RecnIframeComponent, selector: "tg-recn-iframe", ngImport: i0, template: "<div>\n  <iframe style='display: none;' *ngIf=\"recnService.showIframe\" [src]=\"recnService.iframePath\">\n  </iframe>\n</div>", styles: [""], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tg-recn-iframe', template: "<div>\n  <iframe style='display: none;' *ngIf=\"recnService.showIframe\" [src]=\"recnService.iframePath\">\n  </iframe>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.RecnService }]; } });

class RecnIframeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeModule, declarations: [RecnIframeComponent], imports: [CommonModule], exports: [RecnIframeComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RecnIframeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [RecnIframeComponent],
                    exports: [
                        RecnIframeComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RecnIframeComponent, RecnIframeModule };
